import React from 'react';

class Dates extends React.Component {
    render(){
        return (
            <div className="mainContent">
                <div className="textContent">
                    <h2>Event Dates</h2>
                    All dates and times are subject to change or cancellation - adverse weather may force last minute changes!
                    <br/><br/>
                    Please check before coming. Updates will be sent via email to the mailing list and posted on facebook.
                    <br/><br/>
                </div>
                <br/>
                <div className="textContent desktopOnly">
                    <table>
                        <thead>
                            <tr>
                                <th>Day</th>
                                <th>Date</th>
                                <th>Time</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="past">
                                <td>Sunday</td>
                                <td>25th January 2026</td>
                                <td>10.30am - 12.00pm</td>
                            </tr>
                            <tr className="past">
                                <td>Sunday</td>
                                <td>19th April 2026</td>
                                <td>10.30am - 12.00pm</td>
                            </tr>
                            <tr className="next">
                                <td>Sunday</td>
                                <td>12th July 2026</td>
                                <td>10.30am - 12.00pm</td>
                            </tr>
                            <tr>
                                <td>Sunday</td>
                                <td>11th October 2026</td>
                                <td>10.30am - 12.00pm</td>
                            </tr>
                            <tr>
                                <td>Sunday</td>
                                <td>10th January 2027</td>
                                <td>10.30am - 12.00pm</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className = "mobileOnly">
                    <p className="dateLine past">Sunday 25th January 2026<br/>10-30am - 12.00pm<br/></p>
                    <p className="dateLine past">Sunday 19th April 2026<br/>10-30am - 12.00pm<br/></p>
                    <p className="dateLine next">Sunday 12th July 2026<br/>10-30am - 12.00pm<br/></p>
                    <p className="dateLine">Sunday 11th October 2026<br/>10-30am - 12.00pm<br/></p>
                    <p className="dateLine">Sunday 10th January 2027<br/>10-30am - 12.00pm<br/></p>
                </div>
            </div>
        )
    
    }
}

export default Dates;
